import { render, staticRenderFns } from "./ButtonsFinishPayment.vue?vue&type=template&id=c52d188c&scoped=true"
import script from "./ButtonsFinishPayment.vue?vue&type=script&lang=js"
export * from "./ButtonsFinishPayment.vue?vue&type=script&lang=js"
import style0 from "./ButtonsFinishPayment.vue?vue&type=style&index=0&id=c52d188c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52d188c",
  null
  
)

export default component.exports